export class SearchAllResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sections",
            "baseName": "sections",
            "type": "Array<SearchAllSection>",
            "format": ""
        },
        {
            "name": "truncatedSectionIds",
            "baseName": "truncatedSectionIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchAllResponse.attributeTypeMap;
    }
    constructor() {
    }
}
